import { api } from "@/plugins/api";

const state = {
  stats: [],
};

const getters = {
  getAllStats: (state) => state.stats,
};

const actions = {
  async fetchAllStats({ commit }) {
    try {
      const response = await api.get("/stats");
      console.log(response);
      const stats = response.data.data;
      commit("setStats", stats);
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setStats(state, stats) {
    state.stats = stats;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
